import {
  CustomerNotificationActionType,
  CustomerNotificationType,
  INotification
} from '@care-portals/api-interfaces';
import { createAction, props } from '@ngrx/store';
import { NotificationEntity } from './notification.models';

export const loadNotifications = createAction(
  '[Notification] Load Notifications',
  props<{ notificationType: CustomerNotificationType; query: any }>()
);

export const loadNotificationsSuccess = createAction(
  '[Notification] Load Notifications Success',
  props<{ notifications: NotificationEntity[] }>()
);

export const loadNotificationsFailure = createAction(
  '[Notification] Load Notifications Failure',
  props<{ error: any }>()
);

export const addNotification = createAction(
  '[Notification] Add Notification',
  props<{ notification: NotificationEntity }>()
);

export const addNotificationSuccess = createAction(
  '[Notification] Add Notification Success',
  props<{ notification: NotificationEntity }>()
);

export const addNotificationFailure = createAction(
  '[Notification] Add Notification Failure',
  props<{ error: any }>()
);

export const deleteNotification = createAction(
  '[Notification] Delete Notification',
  props<{ id: string }>()
);

export const deleteNotificationSuccess = createAction(
  '[Notification] Delete Notification Success',
  props<{ id: string }>()
);

export const deleteNotificationFailure = createAction(
  '[Notification] Delete Notification Failure',
  props<{ error: any }>()
);

export const clearAllNotification = createAction(
  '[Notification] Clear All Notification'
);

export const onAction = createAction(
  '[Notification] On Action Click',
  props<{ actionType: CustomerNotificationActionType; payload: any }>()
);
